import { render, staticRenderFns } from "./ZiyaratDealCreationBox.vue?vue&type=template&id=150a44fd&"
import script from "./ZiyaratDealCreationBox.vue?vue&type=script&lang=js&"
export * from "./ZiyaratDealCreationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports